export const GET_MANAGE_RECORDING_REQUEST = "GET_MANAGE_RECORDING_REQUEST";
export const GET_MANAGE_RECORDING_SUCCESS = "GET_MANAGE_RECORDING_SUCCESS";
export const GET_MANAGE_RECORDING_FAIL = "GET_MANAGE_RECORDING_FAIL";

export const CREATE_MANAGE_RECORDING_REQUEST = "CREATE_MANAGE_RECORDING_REQUEST";
export const CREATE_MANAGE_RECORDING_SUCCESS = "CREATE_MANAGE_RECORDING_SUCCESS";
export const CREATE_MANAGE_RECORDING_FAIL = "CREATE_MANAGE_RECORDING_FAIL";

export const UPDATE_MANAGE_RECORDING_REQUEST = "UPDATE_MANAGE_RECORDING_REQUEST";
export const UPDATE_MANAGE_RECORDING_SUCCESS = "UPDATE_MANAGE_RECORDING_SUCCESS";
export const UPDATE_MANAGE_RECORDING_FAIL = "UPDATE_MANAGE_RECORDING_FAIL";